$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
SpriteAnime = require './nav-sprite-anime'
{ forEach, map } = require 'lodash'

module.exports =
class Nav extends Singleton

  dotSelector   : 'a'
  isLocatedClass: 'is-located'
  fps           : 30
  sprites: [
    [ 0 ]              # [0] default
    [ 1 ]              # [1] selected
    [ 2, 3, 4 ]        # [2] to bottom start
    [ 5, 6, 7, 8 ]     # [3] to bottom between
    [ 9, 10, 11 ]      # [4] to bottom end
    [ 12, 13, 14 ]     # [5] to top start
    [ 15, 16, 17, 18 ] # [6] to top between
    [ 19, 20, 21 ]     # [7] to top end
  ]

  constructor: ->
    super

    @$window = Elements.$window
      .one 'splashEnded', @onSplashEnded
    @$nav       = Elements.$nav
    @$indicator = Elements.$navIndicator
    @$dot       = @$indicator.find @dotSelector

    @location     = 0
    @spriteCounts = map @$dot, -> 0

    @spriteAnime = map @$dot, (el) =>
      new SpriteAnime el,
        fps    : @fps
        sprites: @sprites

  onSplashEnded: =>
    navY = @$nav.offset().top
    @points = map @$indicator, (el) ->
      $(el).offset().top - navY

  setLocation: (target, isMove = true) ->
    @toggleClass target
    @moveLocated(target) if isMove
    @location = target

  toggleClass: (target) ->
    @$indicator.eq @location
      .removeClass @isLocatedClass
    @$indicator.eq target
      .addClass @isLocatedClass

  moveLocated: (target) ->
    shift = target - @location

    @startTimes = map @$dot, -> new Date().getTime()

    if 0 < shift
      between = shift - 1
      ms      = 1000 / (@fps * (between + 1))
      @spriteAnime[@location].start { th: 2, ms: ms }
      forEach [0...between], (i) =>
        @timer (@location + 1 + i), 3, (2 * i), ms
      @timer target, 4, (2 * between), ms
    else
      between = -(shift + 1)
      ms      = 1000 / (@fps * (between + 1))
      @spriteAnime[@location].start { th: 5, ms: ms }
      forEach [0...between], (i) =>
        @timer (@location - 1 - i), 6, (2 * i), ms
      @timer target, 7, (2 * between), ms

  timer: (target, th, startCount, ms) =>
    status    = new Date().getTime() - @startTimes[target]
    isRestart = true

    if ms < status
      if startCount <= @spriteCounts[target]
        @spriteAnime[target].start { th: th, ms: ms }
        @spriteCounts[target] = 0
        isRestart = false
      else
        @startTimes[target] = new Date().getTime()
        @spriteCounts[target]++

    if isRestart
      @requestId = window.requestAnimationFrame => @timer target, th, startCount, ms



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/nav.coffee